import React from 'react';
import './RestaurantFilters.css';

interface RestaurantFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  locationFilter: string;
  onLocationFilterChange: (location: string) => void;
  stageFilter: string;
  onStageFilterChange: (stage: string) => void;
}

const RestaurantFilters: React.FC<RestaurantFiltersProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  locationFilter,
  onLocationFilterChange,
  stageFilter,
  onStageFilterChange,
}) => {
  return (
    <div className="restaurant-filters">
      <div className="restaurant-search">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search restaurants..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="restaurant-search-input"
        />
      </div>
      <div className="restaurant-filter-controls">
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="restaurant-filter-select"
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Pending</option>
          <option>Inactive</option>
        </select>
        <select
          value={locationFilter}
          onChange={(e) => onLocationFilterChange(e.target.value)}
          className="restaurant-filter-select"
        >
          <option>All Locations</option>
          <option>New York</option>
          <option>Los Angeles</option>
          <option>San Francisco</option>
          <option>Chicago</option>
        </select>
        <select
          value={stageFilter}
          onChange={(e) => onStageFilterChange(e.target.value)}
          className="restaurant-filter-select"
        >
          <option>All Stages</option>
          <option>Verified</option>
          <option>Unverified</option>
        </select>
        <button className="restaurant-more-filters-btn">
          <span>🔽</span> More Filters
        </button>
      </div>
    </div>
  );
};

export default RestaurantFilters;

